import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Calendar, TrendingUp, Award } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export const Landing = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <div 
        className="relative h-screen flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1688487502503-ae289dcb0178?crop=entropy&cs=srgb&fm=jpg&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        data-testid="hero-section"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#064E3B]/90 to-black/90" />
        
        <div className="relative z-10 text-center px-6 max-w-5xl">
          <h1 className="text-5xl md:text-7xl font-heading font-extrabold uppercase tracking-tighter text-white mb-6" data-testid="hero-title">
            TU MEJOR SWING<br />EMPIEZA ACÁ
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto" data-testid="hero-subtitle">
            Entrená con tecnología de punta en San Miguel de Tucumán. Análisis IA de tu swing, reservas online y seguimiento de progreso.
          </p>
          {user ? (
            <Link 
              to="/dashboard" 
              className="inline-block bg-primary text-primary-foreground px-8 py-4 font-bold uppercase tracking-wider hover:bg-primary/90 transition-all duration-300 hover:translate-x-1"
              data-testid="hero-dashboard-button"
            >
              Ir al Dashboard
            </Link>
          ) : (
            <Link 
              to="/register" 
              className="inline-block bg-primary text-primary-foreground px-8 py-4 font-bold uppercase tracking-wider hover:bg-primary/90 transition-all duration-300 hover:translate-x-1"
              data-testid="hero-register-button"
            >
              Empezar Ahora
            </Link>
          )}
        </div>
      </div>

      <div className="py-20 md:py-32 px-6 md:px-12 lg:px-24" data-testid="features-section">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-heading font-bold uppercase tracking-tight text-center mb-16" data-testid="features-title">
            Características
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="glass-effect p-6 hover:border-primary/50 transition-colors duration-300" data-testid="feature-ai">
              <div className="text-accent mb-4">
                <Target size={40} />
              </div>
              <h3 className="text-xl font-semibold mb-3">Profesor Virtual PGA</h3>
              <p className="text-muted-foreground">Análisis IA de tu swing con recomendaciones personalizadas de un experto virtual.</p>
            </div>

            <div className="glass-effect p-6 hover:border-primary/50 transition-colors duration-300" data-testid="feature-booking">
              <div className="text-accent mb-4">
                <Calendar size={40} />
              </div>
              <h3 className="text-xl font-semibold mb-3">Reservas Online</h3>
              <p className="text-muted-foreground">Reservá tu turno en nuestras bahías indoor desde cualquier lugar.</p>
            </div>

            <div className="glass-effect p-6 hover:border-primary/50 transition-colors duration-300" data-testid="feature-tracking">
              <div className="text-accent mb-4">
                <TrendingUp size={40} />
              </div>
              <h3 className="text-xl font-semibold mb-3">Seguimiento de Progreso</h3>
              <p className="text-muted-foreground">Visualizá tu evolución con gráficos y métricas detalladas.</p>
            </div>

            <div className="glass-effect p-6 hover:border-primary/50 transition-colors duration-300" data-testid="feature-vault">
              <div className="text-accent mb-4">
                <Award size={40} />
              </div>
              <h3 className="text-xl font-semibold mb-3">Informes de Entrenamiento</h3>
              <p className="text-muted-foreground">Accedé a todo tu historial de análisis y sesiones de entrenamiento.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="py-20 px-6 md:px-12 lg:px-24 bg-black/40" data-testid="cta-section">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold uppercase tracking-tight mb-6" data-testid="cta-title">
            Llevá tu juego al siguiente nivel
          </h2>
          <p className="text-lg text-muted-foreground mb-8" data-testid="cta-subtitle">
            Tecnología de análisis profesional al alcance de tu mano
          </p>
          {!user && (
            <Link 
              to="/register" 
              className="inline-block bg-primary text-primary-foreground px-8 py-4 font-bold uppercase tracking-wider hover:bg-primary/90 transition-all duration-300"
              data-testid="cta-register-button"
            >
              Crear Cuenta Gratis
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};